/**
 * Mascarade Noire — Les Offrandes Maudites
 * Coffrets scellés (ouverture souris / clavier / tactile), messages de date
 * limite honnêtes calculés côté client, et générateur de carte d'offrande
 * (canvas, 100% local, aucune donnée envoyée nulle part).
 * N'appelle que l'API panier publique /cart/add.js.
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    try {
      var stored = localStorage.getItem('mn-reduced-motion');
      if (stored === 'true') return true;
      if (stored === 'false') return false;
    } catch (e) {}
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function formatDateFr(iso) {
    try {
      var d = new Date(iso + 'T12:00:00');
      return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
    } catch (e) {
      return iso;
    }
  }

  /* ---------------------------------------------------------
     Coffrets
     --------------------------------------------------------- */
  function openChest(chest) {
    var wrap = chest.closest('[data-mn-chest-wrap]') || chest;
    if (wrap.classList.contains('is-open')) return;
    wrap.classList.add('is-open');
    chest.setAttribute('aria-expanded', 'true');
    var card = wrap.querySelector('.mn-gift-card');
    if (card) {
      var focusTarget = card.querySelector('a, button');
      if (focusTarget && !prefersReducedMotion()) {
        window.setTimeout(function () {
          focusTarget.focus({ preventScroll: true });
        }, 550);
      }
    }
    playSealSound();
  }

  function playSealSound() {
    try {
      if (!window.MascaradeConfig || !window.MascaradeConfig.effects || !window.MascaradeConfig.effects.sound) return;
      var audio = new Audio(window.MascaradeConfig.sealCrackSoundUrl || '');
      if (!window.MascaradeConfig.sealCrackSoundUrl) return;
      audio.volume = 0.4;
      audio.play().catch(function () {});
    } catch (e) {}
  }

  function initChests(root) {
    root.querySelectorAll('[data-mn-chest]').forEach(function (chest) {
      chest.setAttribute('aria-expanded', 'false');
      chest.addEventListener('click', function () {
        openChest(chest);
      });
      chest.addEventListener('keydown', function (evt) {
        if (evt.key === 'Enter' || evt.key === ' ' || evt.key === 'Spacebar') {
          evt.preventDefault();
          openChest(chest);
        }
      });
    });

    var openAllBtn = root.querySelector('[data-mn-open-all]');
    if (openAllBtn) {
      openAllBtn.addEventListener('click', function () {
        root.querySelectorAll('[data-mn-chest]').forEach(openChest);
        openAllBtn.style.display = 'none';
      });
    }
  }

  /* ---------------------------------------------------------
     Ajout au panier depuis une fiche
     --------------------------------------------------------- */
  function initAddToCart(root) {
    root.querySelectorAll('[data-mn-gift-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId || btn.disabled) return;
        btn.disabled = true;
        var original = btn.textContent;
        btn.textContent = 'Ajout…';

        // Même circuit que le reste du thème (Horizon) : le compteur du panier
        // et le tiroir se mettent à jour tout seuls.
        var actions = window.Shopify && window.Shopify.actions;
        var request;
        if (actions && typeof actions.updateCart === 'function') {
          request = actions
            .updateCart(
              { lines: [{ merchandiseId: String(variantId), quantity: 1 }] },
              { event: { context: 'standard-action' } }
            )
            .then(function (result) {
              if (result && result.userErrors && result.userErrors.length) {
                throw new Error('add-to-cart-failed');
              }
              if (typeof actions.openCart === 'function') actions.openCart();
            });
        } else {
          request = fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          }).then(function (res) {
            if (!res.ok) throw new Error('add-to-cart-failed');
            return res.json();
          });
        }

        request
          .then(function () {
            btn.textContent = '✓ Ajouté au panier';
            window.setTimeout(function () {
              btn.disabled = false;
              btn.textContent = original;
            }, 2500);
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = original;
          });
      });
    });
  }

  /* ---------------------------------------------------------
     Dates limites : honnête, recalculé au chargement
     --------------------------------------------------------- */
  function initDeadlines(root) {
    var now = new Date();
    root.querySelectorAll('[data-mn-deadline]').forEach(function (el) {
      var iso = el.getAttribute('data-mn-deadline');
      if (!iso) return;
      var deadline = new Date(iso + 'T23:59:59');
      var passed = now > deadline;
      el.setAttribute('data-mn-deadline-passed', passed ? 'true' : 'false');
      el.textContent = passed
        ? 'Une livraison avant Halloween devient peu probable — ça reste un joli cadeau, juste un peu en retard sur la fête.'
        : 'Pour une livraison estimée avant Halloween, commande avant le ' + formatDateFr(iso) + ' (délais indicatifs).';
    });
  }

  /* ---------------------------------------------------------
     Fantôme caché (facultatif, aucun code promo dupliqué)
     --------------------------------------------------------- */
  function initGhost(root) {
    var ghost = root.querySelector('[data-mn-offrandes-ghost]');
    if (!ghost) return;
    var msg = ghost.querySelector('.mn-offrandes__ghost-msg');
    var reveal = function () {
      if (!msg) return;
      msg.classList.add('is-visible');
      window.clearTimeout(ghost._mnTimer);
      ghost._mnTimer = window.setTimeout(function () {
        msg.classList.remove('is-visible');
      }, 3200);
    };
    ghost.addEventListener('click', reveal);
    ghost.addEventListener('focus', reveal);
  }

  /* ---------------------------------------------------------
     Générateur de carte d'offrande (canvas)
     --------------------------------------------------------- */
  var CARD_W = 900;
  var CARD_H = 620;

  var TEMPLATES = {
    glisser: {
      label: 'À glisser avec le cadeau',
      heading: 'Une offrande pour toi',
    },
    mystere: {
      label: 'Annonce mystère',
      heading: 'Un colis maudit est en route…',
    },
  };

  var PRESET_MESSAGES = [
    'Un vrai ami, c’est quelqu’un qui accepte d’être maudit avec toi.',
    'Ceci n’est pas une malédiction. (Enfin… presque pas.)',
    'Trouvé au fond d’un chaudron, gardé spécialement pour toi.',
  ];

  function drawParchment(ctx) {
    var grad = ctx.createLinearGradient(0, 0, CARD_W, CARD_H);
    grad.addColorStop(0, '#e9d9b8');
    grad.addColorStop(1, '#cdb27f');
    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, CARD_W, CARD_H);

    ctx.strokeStyle = 'rgba(74, 42, 21, 0.5)';
    ctx.lineWidth = 6;
    ctx.strokeRect(18, 18, CARD_W - 36, CARD_H - 36);
    ctx.lineWidth = 1.5;
    ctx.strokeRect(28, 28, CARD_W - 56, CARD_H - 56);

    // taches légères pour un effet parchemin, sans texte ni logo tiers
    ctx.save();
    ctx.globalAlpha = 0.08;
    for (var i = 0; i < 14; i++) {
      var rx = 40 + Math.random() * (CARD_W - 80);
      var ry = 40 + Math.random() * (CARD_H - 80);
      var r = 20 + Math.random() * 60;
      ctx.beginPath();
      ctx.fillStyle = '#4a2a15';
      ctx.arc(rx, ry, r, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.restore();
  }

  function drawSeal(ctx, x, y) {
    ctx.save();
    ctx.translate(x, y);
    var grad = ctx.createRadialGradient(-8, -10, 4, 0, 0, 42);
    grad.addColorStop(0, '#8a1230');
    grad.addColorStop(1, '#4a0715');
    ctx.fillStyle = grad;
    ctx.beginPath();
    ctx.arc(0, 0, 42, 0, Math.PI * 2);
    ctx.fill();
    ctx.strokeStyle = '#2c040c';
    ctx.lineWidth = 3;
    ctx.stroke();

    ctx.fillStyle = 'rgba(255,255,255,0.85)';
    ctx.font = '30px "Cinzel Decorative", serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('MN', 0, 2);
    ctx.restore();
  }

  function wrapText(ctx, text, x, y, maxWidth, lineHeight) {
    var words = text.split(' ');
    var line = '';
    var lines = [];
    for (var n = 0; n < words.length; n++) {
      var testLine = line + words[n] + ' ';
      if (ctx.measureText(testLine).width > maxWidth && n > 0) {
        lines.push(line);
        line = words[n] + ' ';
      } else {
        line = testLine;
      }
    }
    lines.push(line);
    lines.forEach(function (l, i) {
      ctx.fillText(l.trim(), x, y + i * lineHeight);
    });
    return lines.length;
  }

  function drawCard(canvas, data) {
    var ctx = canvas.getContext('2d');
    canvas.width = CARD_W;
    canvas.height = CARD_H;

    drawParchment(ctx);

    ctx.fillStyle = '#2a1340';
    ctx.textAlign = 'center';
    ctx.font = '46px "Cinzel Decorative", serif';
    ctx.fillText(TEMPLATES[data.template].heading, CARD_W / 2, 110);

    ctx.font = '20px Inter, sans-serif';
    ctx.fillStyle = '#3a2410';
    ctx.textAlign = 'left';

    if (data.to) {
      ctx.font = '24px Inter, sans-serif';
      ctx.fillText('Pour ' + data.to, 70, 200);
    }

    ctx.font = 'italic 22px Georgia, serif';
    ctx.fillStyle = '#2a1c0d';
    wrapText(ctx, data.message || PRESET_MESSAGES[0], 70, 270, CARD_W - 140, 34);

    if (data.from) {
      ctx.font = '20px Inter, sans-serif';
      ctx.textAlign = 'right';
      ctx.fillText('De la part de ' + data.from, CARD_W - 70, CARD_H - 90);
    }

    drawSeal(ctx, CARD_W - 100, CARD_H - 190);
  }

  function initCardGenerator(root) {
    // Le générateur est rendu juste après la section (hors de root) : on le
    // cherche dans la même section Shopify.
    var scope = root.closest('.shopify-section') || root.parentElement || document;
    var modal = scope.querySelector('[data-mn-card-gen]');
    if (!modal) return;

    var canvas = modal.querySelector('canvas');
    var toInput = modal.querySelector('[data-mn-cg-to]');
    var fromInput = modal.querySelector('[data-mn-cg-from]');
    var msgInput = modal.querySelector('[data-mn-cg-message]');
    var templateBtns = modal.querySelectorAll('[data-mn-cg-template]');
    var presetBtns = modal.querySelectorAll('[data-mn-cg-preset]');
    var statusEl = modal.querySelector('[data-mn-cg-status]');
    var downloadBtn = modal.querySelector('[data-mn-cg-download]');
    var shareBtn = modal.querySelector('[data-mn-cg-share]');
    var closeBtns = modal.querySelectorAll('[data-mn-cg-close]');

    var state = { template: 'glisser', to: '', from: '', message: PRESET_MESSAGES[0] };
    var fontsReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
    var lastFocused = null;

    function redraw() {
      fontsReady.then(function () {
        drawCard(canvas, state);
      });
    }

    templateBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.template = btn.getAttribute('data-mn-cg-template');
        templateBtns.forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        redraw();
      });
    });

    presetBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var text = btn.textContent.trim();
        state.message = text;
        if (msgInput) msgInput.value = text;
        redraw();
      });
    });

    if (toInput) toInput.addEventListener('input', function () { state.to = toInput.value; redraw(); });
    if (fromInput) fromInput.addEventListener('input', function () { state.from = fromInput.value; redraw(); });
    if (msgInput) msgInput.addEventListener('input', function () { state.message = msgInput.value; redraw(); });

    function openModal(productTitle) {
      lastFocused = document.activeElement;
      modal.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
      if (statusEl) statusEl.textContent = '';
      if (toInput) toInput.focus();
      redraw();
    }

    function closeModal() {
      modal.classList.remove('is-visible');
      document.body.style.overflow = '';
      if (lastFocused) lastFocused.focus();
    }

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });
    modal.addEventListener('click', function (evt) {
      if (evt.target === modal) closeModal();
    });
    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape' && modal.classList.contains('is-visible')) closeModal();
    });

    root.querySelectorAll('[data-mn-open-card-gen]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openModal(btn.getAttribute('data-mn-product-title'));
      });
    });

    function getBlob() {
      return new Promise(function (resolve) {
        canvas.toBlob(function (blob) {
          resolve(blob);
        }, 'image/png');
      });
    }

    if (downloadBtn) {
      downloadBtn.addEventListener('click', function () {
        getBlob().then(function (blob) {
          if (!blob) {
            if (statusEl) statusEl.textContent = 'Le téléchargement a échoué, réessaie.';
            return;
          }
          var url = URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = url;
          a.download = 'carte-offrande-mascarade-noire.png';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
          if (statusEl) statusEl.textContent = 'Carte téléchargée.';
        });
      });
    }

    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        getBlob().then(function (blob) {
          if (!blob) return;
          var file = new File([blob], 'carte-offrande.png', { type: 'image/png' });
          if (navigator.canShare && navigator.canShare({ files: [file] })) {
            navigator
              .share({ files: [file], title: 'Une offrande pour toi' })
              .catch(function () {});
          } else if (downloadBtn) {
            downloadBtn.click();
            if (statusEl) statusEl.textContent = 'Partage indisponible ici : la carte a été téléchargée à la place.';
          }
        });
      });
    }
  }

  /* ---------------------------------------------------------
     Boot
     --------------------------------------------------------- */
  function boot() {
    document.querySelectorAll('[data-mn-offrandes]').forEach(function (root) {
      if (root.dataset.mnOffrandesInit === 'true') return;
      root.dataset.mnOffrandesInit = 'true';
      initChests(root);
      initAddToCart(root);
      initDeadlines(root);
      initGhost(root);
      initCardGenerator(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);
})();
